import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const IncidentTypePage = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'type', label: 'Incident Type' },
    { key: 'severity', label: 'Severity' },
    { key: 'reportable', label: 'State Reportable' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'Code', type: 'text', required: true },
    { key: 'type', label: 'Incident Type', type: 'text', required: true },
    { key: 'severity', label: 'Severity', type: 'select', required: true, options: [
      { value: 'Minor', label: 'Minor' },
      { value: 'Moderate', label: 'Moderate' },
      { value: 'Major', label: 'Major' },
      { value: 'Critical', label: 'Critical' },
    ]},
    { key: 'reportable', label: 'State Reportable', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]},
    { key: 'description', label: 'Description', type: 'textarea', required: false, fullWidth: true },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: 'FALL', type: 'Patient Fall', severity: 'Major', reportable: 'Yes', active: 'Yes' },
    { id: '2', code: 'MEDEER', type: 'Medication Error', severity: 'Major', reportable: 'Yes', active: 'Yes' },
    { id: '3', code: 'SKIN', type: 'Skin Integrity Issue', severity: 'Moderate', reportable: 'No', active: 'Yes' },
    { id: '4', code: 'INFECT', type: 'Infection', severity: 'Major', reportable: 'Yes', active: 'Yes' },
    { id: '5', code: 'EQUIP', type: 'Equipment Malfunction', severity: 'Minor', reportable: 'No', active: 'Yes' },
    { id: '6', code: 'ABUSE', type: 'Abuse/Neglect Allegation', severity: 'Critical', reportable: 'Yes', active: 'Yes' },
    { id: '7', code: 'ELOPMT', type: 'Patient Elopement', severity: 'Critical', reportable: 'Yes', active: 'Yes' },
    { id: '8', code: 'HIPAA', type: 'HIPAA Breach', severity: 'Major', reportable: 'Yes', active: 'Yes' },
    { id: '9', code: 'COMPLT', type: 'Patient Complaint', severity: 'Minor', reportable: 'No', active: 'Yes' },
    { id: '10', code: 'OTHER', type: 'Other Incident', severity: 'Minor', reportable: 'No', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="Incident Type"
      columns={columns}
      initialData={initialData}
      addButtonText="Add Type"
      formFields={formFields}
      apiEndpoint="/setup/incident-type"
    />
  );
};

export default IncidentTypePage;
